import React from "react";

import Button from "components/botanic/Button";
import Image from "components/Image";

const WantHelp = (): JSX.Element => (
  <div className="bg-white px-lg py-xxl lg:px-xxl flex flex-col lg:flex-row my-xxl container">
    <div className="flex-1 order-2 lg:order-1 p-lg lg:mx-xl text-center lg:text-left basis-1/2">
      <h3 className="heading--xl">Want help?</h3>
      <div className="my-lg mb-xxl text-sm">
        Answer a few questions for our virtual budtender and meet your cannabis
        match.
      </div>
      <a href="https://www.leafly.com/virtual-budtender">
        <Button className="m-auto lg:ml-none">let's go</Button>
      </a>
    </div>
    <div className="order-1 lg:order-2 flex p-lg mx-lg justify-center basis-1/2">
      <div className="basis-1/2">
        <Image
          src={
            "https://s3-us-west-2.amazonaws.com/leafly-images/flower-images/blue-dream.png"
          }
          sizes={[85, 85, 180, 180, 180, 180]}
          alt="Blue Dream nugget"
        />
      </div>
      <div className="basis-1/2">
        <Image
          src={
            "https://public.leafly.com/strains/flowers/blue-dream-flower.svg"
          }
          sizes={[85, 85, 180, 180, 180, 180]}
          alt="Leafly Blue Dream Flower"
        />
      </div>
    </div>
  </div>
);

export default WantHelp;
